import axios from 'axios';
import React from 'react';
import Joyride from 'react-joyride';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import { descobrirContrato } from '../../actions/ContratoActions';
import { enviarEmail } from '../../actions/EmailActions';
import { obterFormandosPeloContrato } from '../../actions/FormandoActions';
import { URL_NEW_MAPA_API } from '../../config/urls';
import EmailServices from '../../services/EmailService';
import { Card, Button, Typography, Row, Col, Descriptions, Tag } from 'antd';
import { FilePdfOutlined, MailOutlined, UserOutlined, CalendarOutlined, FileTextOutlined } from '@ant-design/icons';
import './styles.css';
class Contrato extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contratos: [],
      usuarios: [],
      iniciouTabela: false,
      novosItens: [],
      quantidade: 0,
      run: false,
      datatables: ['datatableFormandos'],
      steps: [
        {
          content: (
            <div>
              <h3>Bem-vindo(a) a página do contrato!</h3>{' '}
              <span style={{ textAlign: 'center' }}>
                É aqui que você poderá ver as informações gerais do seu
                contrato.
              </span>
            </div>
          ),
          placement: 'center',
          target: '#divContent',
        },
        {
          content: (
            <div>
              <h3>Informações do contrato</h3>{' '}
              <span style={{ textAlign: 'center' }}>
                Você poderá ver as informações do seu contrato aqui.
              </span>
            </div>
          ),
          placement: 'bottom',
          target: '#dadosGerais',
        },
        // ,
        // {
        //   content: <div><h3>Tabela de formandos cadastrados</h3> <span style={{textAlign: "center"}}>Você poderá ver todos os formandos cadastrados, bem como a sua senha de acesso.</span></div>,
        //   placement: 'bottom',
        //   target: '#datatableFormandos'
        // }
      ],
    };
  }

  componentWillMount() {
    if (localStorage.getItem('tutorialContrato') === null) {
      this.setState({ run: true });
      localStorage.setItem('tutorialContrato', true);
    }
    this.props
      .descobrirContrato(
        this.props.usuario.tipo,
        this.props.usuario.tipo === 'formando'
          ? this.props.numeroContrato
          : this.props.usuario.id
      )
      .then(() => {
        this.props.obterFormandosPeloContrato(this.props.contrato.id);
      });
  }

  enviarAcesso() {
    let email = new EmailServices();
    email.enviar('getTemplateReenviarSenhaAcesso', {
      email: this.props.contrato.usuario.email,
      senha: this.props.contrato.usuario.senha,
      nome: this.props.contrato.usuario.nome,
    });
  }

  componentDidMount() {
    // Legacy support removal
  }

  componentWillUpdate() {
    // Legacy support removal
  }

  componentDidUpdate() {
    // Legacy support removal
  }

  async getPdfContract() {
    axios
      .get(
        `${URL_NEW_MAPA_API}/contract/${this.props.contrato.numero}/signed-pdf`,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization:
              'Bearer 3bca4df63f1cc72e4c8ad364a5d426f77e65f5084b40be712cf0bc4ed34ac61e',
          },
        }
      )
      .then((response) => {
        if (window.confirm('Abrir PDF em nova aba?')) {
          window.open(response.data.url, '_blank');
        }
      })
      .catch((erro) => {
        toast.error(
          'Não foi possível encontrar o contrato em nossa base de dados!'
        );
      });
  }

  render() {
    if (this.props.contrato.status === 'deletado') {
      return <Redirect to='/deletado' />;
    }

    const { Title, Text } = Typography;
    const primaryColor = '#d32f2f'; // Company Brand Red

    return (
      <div style={{ padding: '24px', backgroundColor: '#f0f2f5', minHeight: '100vh', display: 'flex', justifyContent: 'center' }}>
        <Row justify="center" style={{ width: '100%', maxWidth: '900px' }}>
          <Col span={24}>

            <div style={{ marginBottom: 32, textAlign: 'center' }}>
              <Title level={2} style={{ color: '#212121', marginBottom: 8, fontWeight: 'bold' }}>Meu Contrato</Title>
              <Text type="secondary" style={{ fontSize: '16px' }}>Gerencie as informações principais do seu contrato de formatura.</Text>
            </div>

            <Card
              id='divContent'
              bordered={false}
              style={{
                borderRadius: '16px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                overflow: 'hidden'
              }}
              bodyStyle={{ padding: 0 }}
            >
              {/* Card Header Custom */}
              <div style={{
                backgroundColor: '#fff',
                padding: '32px',
                borderBottom: '1px solid #f0f0f0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}>
                <div style={{
                  backgroundColor: '#ffebee',
                  borderRadius: '50%',
                  width: 80,
                  height: 80,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: 16,
                  boxShadow: '0 4px 12px rgba(211, 47, 47, 0.2)'
                }}>
                  <FileTextOutlined style={{ fontSize: 36, color: primaryColor }} />
                </div>
                <Text type="secondary" style={{ fontSize: 12, letterSpacing: '1px', textTransform: 'uppercase', fontWeight: 600 }}>Número do Contrato</Text>
                <Title level={3} style={{ margin: '4px 0 16px', color: '#212121', fontWeight: 800 }}>{this.props.contrato.numero}</Title>
              </div>

              <div id='dadosGerais' style={{ padding: '32px' }}>
                <Descriptions
                  column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                  layout="horizontal"
                  colon={false}
                  bordered={false}
                  size="middle"
                >

                  <Descriptions.Item
                    style={{ paddingBottom: 16 }}
                    label={<span style={{ fontWeight: 600, fontSize: '15px', color: '#424242', width: 160, display: 'inline-block' }}><MailOutlined style={{ marginRight: 10, color: '#9e9e9e' }} /> E-mail Principal</span>}
                  >
                    <Text style={{ fontSize: '15px', color: '#616161' }}>{this.props.contrato.emailComissao}</Text>
                  </Descriptions.Item>

                  <Descriptions.Item
                    style={{ paddingBottom: 16 }}
                    label={<span style={{ fontWeight: 600, fontSize: '15px', color: '#424242', width: 160, display: 'inline-block' }}><UserOutlined style={{ marginRight: 10, color: '#9e9e9e' }} /> Gestor(a)</span>}
                  >
                    <Tag color="default" style={{ border: 'none', color: '#424242', backgroundColor: '#f5f5f5', fontSize: '14px', padding: '4px 12px', borderRadius: '4px' }}>
                      {this.props.contrato.dono.nome || 'Não definido'}
                    </Tag>
                  </Descriptions.Item>

                  <Descriptions.Item
                    style={{ paddingBottom: 0 }}
                    label={<span style={{ fontWeight: 600, fontSize: '15px', color: '#424242', width: 160, display: 'inline-block' }}><CalendarOutlined style={{ marginRight: 10, color: '#9e9e9e' }} /> Data de Início</span>}
                  >
                    <Text style={{ fontSize: '15px', color: '#616161' }}>{new Date(this.props.contrato.dataInicio).toLocaleDateString()}</Text>
                  </Descriptions.Item>

                </Descriptions>
              </div>
            </Card>

            <Joyride
              steps={this.state.steps}
              continuous={true}
              run={this.state.run}
              scrollToFirstStep={true}
              showProgress={true}
              showSkipButton={true}

              locale={{
                back: 'Voltar',
                close: 'Fechar',
                last: 'Entendi',
                next: 'Próximo',
                skip: 'Pular'
              }}
              styles={{
                options: {
                  primaryColor: primaryColor,
                  zIndex: 10000
                }
              }}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    contrato: state.contrato.especifico,
    formandos: state.formando.todos,
    numeroContrato: state.usuario.numeroContrato,
  };
};

export default connect(mapStateToProps, {
  enviarEmail,
  descobrirContrato,
  obterFormandosPeloContrato,
})(Contrato);
